module.exports = __webpack_public_path__ + "static/media/SquareDefaultImg_small.a038c40b.png";